import axios from "@/libs/api.request";
import { getToken } from "@/libs/util";

// 获取轨迹错误列表
export const getErrorTracker = data => {
  return axios.request({
    url: "/tracker/trace/trackerErrorList",
    method: "post",
    data
  });
};
// 提交方案
export const add = data => {
  return axios.request({
    url: "/tracker/trace/trackerErrorOpinion",
    method: "put",
    data
  });
};

// 忽略错误
export const ignore = data => {
  return axios.request({
    url: "/tracker/trace/ignore",
    method: "post",
    data
  });
};
